import { RefObject } from "react";

export const calculateRoiSquareSize = (
  imageRef: RefObject<HTMLImageElement>,
  e: any,
  roiSize: number,
) => {
  if (imageRef.current) {
    const { naturalHeight } = e.target;
    return (imageRef.current.clientHeight / naturalHeight) * roiSize;
  }
  return 0;
};
